import {
  Box,
  Button,
  Grid,
  LinearProgress,
  Typography,
  Alert,
  IconButton,
  Menu,
  MenuItem,
} from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { API_ENDPOINT } from '../../../configurations/global.config';
import { useParams } from 'react-router-dom';
import React, { useContext, useState } from 'react';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import axios, { AxiosResponse } from 'axios';
import { IDeliveryBatch } from '../../../interfaces/delivery-company/tasks';
import { AuthContext } from '../../../contexts/user-context/user-context';
import {
  NotificationTemplate,
  OrderType,
  OrganisationSettings,
} from '../../../interfaces/delivery-company/orders';
import { DeliveryBatchState } from '../../../enums/tasks';
import HourglassBottomIcon from '@mui/icons-material/HourglassBottom';
import MultiPackageScanner, {
  timestampedMessage,
  validationResult,
} from '../../common/multi-package-scanner/multi-package-scanner';
import { DeliveryState, Workflow } from '../../../enums/orders';
import { displayLocation } from '../../../utils/locations';
import { GenericTableProps } from '../../common/generic-table/utils';
import {
  Decoding,
  DecodingWithOrderVal,
  generateUID,
  transformOrdersToDecodingWithOrderVal,
} from '../../../utils/encoding';

interface DriverDeliveryBatchPageProps {
  deliverytaskId: string;
  onClose: () => void;
  setSnackBarResult: (t?: timestampedMessage) => void;
  onSuccess?: () => void;
}
function DriverDeliveryBatchPage({
  deliverytaskId,
  onClose,
  setSnackBarResult,
  onSuccess,
}: DriverDeliveryBatchPageProps) {
  const { user, config } = useContext(AuthContext);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [response, setResponse] = useState<AxiosResponse>();
  const [message, setMessage] = useState<string>('');
  const [deliveryBatchData, setDeilveryTaskData] = useState<IDeliveryBatch>();

  async function scanOrder(order_id: string): Promise<boolean> {
    try {
      const requestData = {
        delivery_state: DeliveryState.SCANNED_FOR_DELIVERY,
      };
      const url = `${API_ENDPOINT}/api/v1/order/${order_id}/`;
      console.log(url);
      const newResponse = await axios.patch(url, requestData, config);
      setResponse(newResponse);
      if (response?.status === 200) return true;
      else return false;
    } catch (e) {
      if (axios.isAxiosError(e)) {
        setResponse(e.response);
        return false;
      } else {
        return false;
      }
    }
  }

  React.useEffect(() => {
    const getAndSetTaskDetails = async () => {
      if (deliverytaskId !== undefined) {
        setIsLoading(true);
        try {
          const endpoint = `${API_ENDPOINT}/api/v1/delivery-batch/${deliverytaskId}/`;
          const response = await axios.get<IDeliveryBatch>(endpoint, config);
          setResponse(response);
          setDeilveryTaskData(response.data);
          console.log(response.data);
        } catch (e) {
          setDeilveryTaskData(undefined);
          if (axios.isAxiosError(e)) {
            setMessage('Failed to load delivery batch data: ' + e.message);
            setResponse(e.response);
          } else {
            setMessage('Failed to load delivery batch data');
          }
          console.log(e);
        }
        setIsLoading(false);
      }
    };
    getAndSetTaskDetails();
  }, [deliverytaskId]);

  const completeDeliveryBatch = async (
    orders: DecodingWithOrderVal[],
    setIsLoading: (isLoading: boolean) => void,
    setResponse: (resp?: AxiosResponse) => void,
    setMessage: (m: string) => void,
    config: any
  ) => {
    if (!deliveryBatchData) {
      setMessage(`Task Not Found`);
      return;
    }
    setIsLoading(true);
    setResponse(undefined);
    try {
      const requestData = {
        status: DeliveryBatchState.OUT_FOR_DELIVERY,
      };

      const url = `${API_ENDPOINT}/api/v1/delivery-batch/${deliveryBatchData.id}/`;
      const newResponse = await axios.patch(url, requestData, config);
      setResponse(newResponse);
      setMessage(
        'Packages collected successfully.Good luck delivering packages!'
      );

      const newValue = {
        timestamp: Date.now(),
        content:
          'Packages collected successfully.Good luck delivering packages!',
        level: 'success',
      };
      setSnackBarResult(newValue as timestampedMessage);
      if (onSuccess) onSuccess();
      onClose();
    } catch (e) {
      if (axios.isAxiosError(e)) {
        setResponse(e.response);
        setMessage(`Failed to complete task: ${e.response?.statusText}`);
        setSnackBarResult;
        const newValue = {
          timestamp: Date.now(),
          content: 'An Error Occured!',
          level: 'error',
        };
        setSnackBarResult(newValue as timestampedMessage);
      } else {
        setMessage('Failed to complete task.');
        setSnackBarResult;
        const newValue = {
          timestamp: Date.now(),
          content: 'An Error Occured!',
          level: 'error',
        };
        setSnackBarResult(newValue as timestampedMessage);
      }
    }

    setIsLoading(false);
  };

  let expectedPackages: DecodingWithOrderVal[] = [];
  let scannedPackages: DecodingWithOrderVal[] = [];

  if (deliveryBatchData) {
    deliveryBatchData.orders.forEach((order) => {
      console.log('tttt' + order.delivery_state);
    });
    expectedPackages = transformOrdersToDecodingWithOrderVal(
      deliveryBatchData.orders.filter(
        (order) => order.delivery_state === DeliveryState.DELIVERY_ASSIGNED
      )
    );
    scannedPackages = [
      ...transformOrdersToDecodingWithOrderVal(
        deliveryBatchData.orders.filter(
          (order) => order.delivery_state !== DeliveryState.DELIVERY_ASSIGNED
        )
      ),
    ];
  }

  console.log('aaa' + scannedPackages);

  return (
    <Box sx={{ p: 2 }}>
      {isLoading ? (
        <LinearProgress />
      ) : (
        <>
          {deliveryBatchData ? (
            <>
              <MultiPackageScanner
                label={'package id'}
                //   disabled={deliveryBatchData.status != PickupTaskState.IN_PROGRESS}
                acceptTemporaryOrders={false}
                commitFun={async (
                  decoding: DecodingWithOrderVal,
                  scannedPkgs: DecodingWithOrderVal[]
                ) => {
                  if (
                    decoding.number_of_packages ==
                    scannedPkgs.filter((pkg) => pkg.id === decoding.id).length +
                      1
                  ) {
                    if (await scanOrder(decoding.order.id)) {
                      return true;
                    }
                    return false;
                  }
                  return true;
                }}
                validator={(decodingWithVal: DecodingWithOrderVal) => {
                  if (
                    decodingWithVal.order.delivery_state !==
                    DeliveryState.DELIVERY_ASSIGNED
                  )
                    return {
                      validated: false,
                      error: 'order not assigned for delivery.',
                    };

                  return { validated: true };
                }}
                callback={completeDeliveryBatch}
                actionType={'Confirm Collection'}
                expectedOrders={expectedPackages}
                defaultScannedOrders={scannedPackages}
                getRenderOrdersProps={function (
                  decodings: DecodingWithOrderVal[]
                ): GenericTableProps<DecodingWithOrderVal> {
                  return {
                    sourceView: "driver-delivery-batch-page",
                    items: decodings,
                    fullWidth: true,
                    columns: [
                      {
                        id: 'order_id',
                        header: 'Order ID',
                        display_body: (decoding) => (
                          <>
                            {decoding.order.order_id}{' '}
                            {decoding.type === 'temporary' && (
                              <div
                                style={{
                                  display: 'flex',
                                  alignContent: 'center',
                                  justifyItems: 'center',
                                  gap: 2,
                                }}
                              >
                                <HourglassBottomIcon fontSize="small" />
                                {decoding.id}
                              </div>
                            )}
                          </>
                        ),
                      },
                    ],
                    getItemUID: (decoding) => generateUID(decoding),
                    selectedItems: new Map(),
                    isLoading: false,
                  };
                }}
                allowUndoScan
              />
            </>
          ) : (
            <LinearProgress />
          )}
        </>
      )}
    </Box>
  );
}

export default DriverDeliveryBatchPage;
